import { Component } from 'react'

class ErrorBoundary extends Component {
    constructor(props) {
        super(props)
        this.state = { hasError: false }
    }

    static getDerivedStateFromError() {
        return { hasError: true }
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className="flex flex-col items-center justify-center min-h-screen gap-4 text-center">
                    <h2 className="text-xl font-semibold text-black dark:text-white">Something went wrong</h2>
                    <p className="text-gray-500 dark:text-gray-400">Please refresh the page or try again later.</p>
                    <button
                        className="px-6 py-2 text-white transition border rounded-lg border-primary bg-primary dark:border-secondary dark:bg-secondary hover:bg-opacity-90"
                        onClick={() => this.setState({ hasError: false })}
                    >
                        Try again
                    </button>
                </div>
            )
        }

        return this.props.children
    }
}

export default ErrorBoundary
